import { memo } from "react";

import { ManagedUserGroup } from "types/generated";

import IdpGroupMappingListDropdown from "../Dropdown";

type IdpGroupDropdownCellProps = {
  group: ManagedUserGroup;
};

const IdpGroupDropdownCell = ({ group }: IdpGroupDropdownCellProps) => {
  return <IdpGroupMappingListDropdown item={group} />;
};

export default memo(IdpGroupDropdownCell);
